import { Paper, Stack, Typography } from '@mui/material';
import { Answer, EffectQuestion, Perspectives } from 'features/lead/lead-questionnaire/lead-questionnaire.types';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import SubCategoryContainer from './sub-category-container';

interface Props {
  perspective?: Perspectives;
  effectQuestions: EffectQuestion[];
  answers: Answer[];

  handleRadioSelectionChange?(id: string): (value: string | number) => () => void;
}

const EffectQuestionsContainer: React.FC<Props> = ({ perspective, effectQuestions, answers, handleRadioSelectionChange }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Stack gap={4}>
      <Typography className={classes.title}>{t('leadQuestionnaireEffectiveLead')}</Typography>
      {perspective === Perspectives.SELF ? (
        <Typography className={classes.description}>
          <Trans i18nKey={'leadQuestionnaireEffectiveLeadSelfPerspectiveText'}>
            Im letzten Teil des Fragebogens geht es um die <b>Auswirkungen Ihres Führungs- und Einflussverhaltens. </b>
            Bitte schätzen Sie ein, wie häufig folgende Aussagen zutreffen.
          </Trans>
        </Typography>
      ) : (
        <Typography className={classes.description}>
          <Trans i18nKey={'leadQuestionnaireEffectiveLeadOtherPerspectiveText'}>
            Im letzten Teil des Fragebogens geht es um die <b>Auswirkungen des Führungs- und Einflussverhaltens</b> von Herrn/Frau X. Bitte schätzen
            Sie ein, wie häufig folgende Aussagen auf Herrn/Frau X zutreffen.
          </Trans>
        </Typography>
      )}
      <Stack gap={2}>
        <Stack gap={2}>
          {effectQuestions.map(
            (subCategory) =>
              subCategory.questions.length !== 0 && (
                <Paper key={subCategory.id} className={classes.textContainer} elevation={2} square={true}>
                  <SubCategoryContainer
                    key={subCategory.id}
                    perspective={perspective}
                    subCategory={subCategory}
                    answers={answers}
                    handleRadioSelectionChange={handleRadioSelectionChange}
                  />
                </Paper>
              )
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(32),
    textAlign: 'center',
    fontWeight: 'bold',
  },
  description: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.greys.medium,
    padding: '0 16px',
  },
  textContainer: {
    background: 'rgba(0,0,0,0.03)',
  },
}));

export default EffectQuestionsContainer;
